.fields {
  /* Neutralize default RDP chrome; mockup tokens drive the look. */
  --rdp-accent-color: #0f4f24;
  --rdp-accent-background-color: #1b7f381f;
  --rdp-today-color: var(--pc-mint-bright, #42d16d);
  --rdp-selected-border: none;
  --rdp-day_button-border: none;
  --rdp-range_middle-background-color: transparent;
  --rdp-range_middle-color: #fff;
  --rdp-range_start-color: #fff;
  --rdp-range_end-color: #fff;
  --rdp-range_start-background: transparent;
  --rdp-range_end-background: transparent;
  --rdp-range_start-date-background-color: transparent;
  --rdp-range_end-date-background-color: transparent;
  --rdp-day-height: 34px;
  --rdp-day-width: 34px;
  --rdp-day_button-height: 34px;
  --rdp-day_button-width: 34px;
  --rdp-day_button-border-radius: 9px;
  --rdp-nav-height: 30px;
  --rdp-weekday-opacity: 1;
  --rdp-outside-opacity: 1;

  position: relative;
  width: 100%;
  color: var(--pc-ink, #fff);
  color-scheme: dark;
}

.fields--sm {
  margin-top: 12px;
}

/* Mockup `.pcsel__btn` / `.rt-ed__cal .pcsel__btn` — single range trigger */
.trigger {
  display: flex;
  align-items: center;
  gap: 9px;
  width: 100%;
  height: 44px;
  padding: 0 14px;
  border: 1px solid var(--pc-bd, #242b33);
  border-radius: 11px;
  background: var(--pc-well, #02070d80);
  color: #fff;
  font: inherit;
  font-size: 14px;
  text-align: left;
  cursor: pointer;
  outline: none;
  transition: border-color 0.13s ease-in-out;

  &:hover {
    border-color: var(--pc-bd2, #2c333b);
  }

  &:hover .calIcon,
  &--active .calIcon {
    color: var(--pc-green, #1aac44);
  }

  &:focus-visible,
  &--active {
    border-color: var(--pc-green, #1aac44);
  }
}

.fields--sm .trigger {
  height: 34px;
  padding: 0 11px;
  border-radius: 9px;
  font-size: 12.5px;
  gap: 8px;
}

/* Mockup `.rdf__cal` */
.calIcon {
  flex: 0 0 auto;
  width: 18px;
  height: 18px;
  color: var(--pc-dim, #74787d);
  transition: color 0.13s ease-in-out;
}

.fields--sm .calIcon {
  width: 16px;
  height: 16px;
}

.triggerValue {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;

  &--empty {
    color: var(--pc-placeholder, #5c6570);
  }
}

/* Mockup `.rdf__pop` / `.pcsel__list` */
.popover {
  position: absolute;
  z-index: 40;
  top: calc(100% + 6px);
  left: 0;
  width: 284px;
  max-width: min(100vw - 24px, 284px);
  padding: 14px;
  border: 1px solid var(--pc-bd, #232931);
  border-radius: 14px;
  background: #0b1116;
  box-shadow: 0 24px 50px -20px #000000cc;
  color: var(--pc-ink, #fff);
}

/* Mockup `.rdc__hint` */
.hint {
  margin: 10px 0 0;
  color: var(--pc-dim, #74787d);
  font-size: 12px;
  text-align: center;
}

/* Mockup `.rdc__top` */
.caption {
  display: flex !important;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  height: auto !important;
  font-weight: 600 !important;
  font-size: 14px !important;
}

.navBtn {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  padding: 0;
  border: 1px solid var(--pc-bd, #232931);
  border-radius: 9px;
  background: #02070d80;
  color: #fff;
  font: inherit;
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
  transition: border-color 0.13s ease-in-out;

  &:hover:not(:disabled) {
    border-color: var(--pc-green, #1aac44);
  }

  &:disabled {
    opacity: 0.35;
    cursor: default;
  }
}

/* Mockup `.rdc__m` */
.monthLabel {
  flex: 1 1 auto;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
}

.picker {
  width: 100%;

  :global(.rdp-months),
  :global(.rdp-month),
  :global(.rdp-month_grid) {
    width: 100%;
    max-width: none;
  }

  :global(.rdp-month_grid) {
    border-collapse: separate;
    border-spacing: 2px;
  }

  /* Kill default caption weight/size; our .caption owns layout. */
  :global(.rdp-month_caption) {
    font-size: 14px;
    font-weight: 600;
    color: #fff;
  }

  /* Hide any leftover default nav if present. */
  :global(.rdp-nav) {
    display: none;
  }

  /* Mockup `.rdc__w` */
  :global(.rdp-weekday) {
    padding: 4px 0;
    color: var(--pc-dim, #74787d);
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0;
    text-transform: uppercase;
    text-align: center;
  }

  :global(.rdp-day) {
    width: auto;
    height: 34px;
    padding: 0;
  }

  /* Mockup `.rdc__d` */
  :global(.rdp-day_button) {
    width: 100%;
    height: 34px;
    border: 0 !important;
    border-radius: 9px;
    background: transparent;
    color: #d7dce1;
    font: inherit;
    font-size: 13px;
    font-weight: 400;
    outline: none;
    box-shadow: none;
    transition: background 0.12s ease, color 0.12s ease;

    &:hover:not(:disabled):not([aria-disabled="true"]) {
      background: #1b7f381f;
      color: #fff;
      border-color: transparent;
    }

    &:focus-visible {
      outline: none;
      box-shadow: inset 0 0 0 1px var(--pc-green, #1aac44);
    }
  }

  /* Kill default `.rdp-selected` chrome (large bold + accent border). */
  :global(.rdp-selected) {
    font-weight: inherit;
    font-size: inherit;
  }

  :global(.rdp-selected .rdp-day_button) {
    border: 0 !important;
  }

  /* Outside / empty — mockup `.is-off` */
  :global(.rdp-outside) {
    opacity: 1;
  }

  :global(.rdp-outside .rdp-day_button) {
    color: #3a4048;
  }

  :global(.rdp-outside .rdp-day_button:hover:not(:disabled):not([aria-disabled="true"])) {
    background: transparent;
    color: #3a4048;
  }

  :global(.rdp-today:not(.rdp-selected) .rdp-day_button) {
    color: var(--pc-mint-bright, #42d16d);
    font-weight: 600;
  }

  /* Neutralize cell-level range washes (source of blue-ish outlines). */
  :global(.rdp-range_start),
  :global(.rdp-range_end),
  :global(.rdp-range_middle) {
    background: transparent !important;
  }

  /* Range middle — mockup `.is-mid` */
  :global(.rdp-range_middle .rdp-day_button) {
    border: 0 !important;
    border-radius: 9px;
    background: #1b7f381f !important;
    color: #fff !important;
    font-weight: 400;
    box-shadow: none;
  }

  /* Selected ends — mockup `.is-on` */
  :global(.rdp-range_start .rdp-day_button),
  :global(.rdp-range_end .rdp-day_button),
  :global(.rdp-selected:not(.rdp-range_middle) .rdp-day_button) {
    background: #0f4f24 !important;
    color: #fff !important;
    font-weight: 600;
    border: 0 !important;
    border-radius: 9px;
    box-shadow: inset 0 0 0 1px #1aac4480;
  }

  :global(.rdp-range_start.rdp-range_end) {
    background: transparent !important;
  }
}
